import { ReactNode } from "react";
import TooltipIcon from "../common/TooltipIcon";
import Tooltip from "../common/Tooltip";
import {
  ArrowPathIcon,
  ArrowRightStartOnRectangleIcon,
} from "@heroicons/react/24/outline";
import cn from "classnames";

interface TooltipWrapperProps {
  label: string | ReactNode;
  description: string | ReactNode;
  showAgencyIcon?: boolean;
  onAgencyIconClick?: () => void;
  showPushIcon?: boolean;
  onPushIconClick?: () => void;
  labelSize?: "sm" | "base";
}

// Centralized tooltip wrapper component
export const TooltipWrapper: React.FC<TooltipWrapperProps> = ({
  label,
  description,
  showAgencyIcon,
  onAgencyIconClick,
  showPushIcon,
  onPushIconClick,
  labelSize = "base",
}) => {
  return (
    <span className="flex items-center">
      <span
        className={cn(
          "text-gray-800 dark:text-base-content/80 font-medium text-xs",
          labelSize === "sm" ? "md:text-sm" : "md:text-base"
        )}
      >
        {label}
      </span>
      <TooltipIcon
        description={description}
        size={labelSize === "sm" ? "sm" : "md"}
      />
      {showAgencyIcon && (
        <Tooltip placement="top" overlay={`Apply agency setting for ${label}`}>
          <ArrowPathIcon
            className="size-5 text-blue-500 dark:text-blue-300 cursor-pointer hover:text-blue-700 dark:hover:text-blue-200 transition-colors ml-1"
            onClick={onAgencyIconClick}
          />
        </Tooltip>
      )}
      {showPushIcon && (
        <Tooltip placement="top" overlay={`Push this setting to all officers.`}>
          <ArrowRightStartOnRectangleIcon
            className="size-5 text-blue-500 dark:text-blue-300 cursor-pointer hover:text-blue-700 dark:hover:text-blue-200 transition-colors ml-1"
            onClick={onPushIconClick}
          />
        </Tooltip>
      )}
    </span>
  );
};
